// @flow

export type LicensingInfo = {
  maintenanceEndDate: string,
  serialNumbers: ?Array<string>,
};

export type System = {
  systemId: string,
  licensingInfo: LicensingInfo,
};

export type LicenseState = {
  isPendingResponse: boolean,
  extensisAccount: ?string,
  licenseMaintenanceEndDate: ?string,
  extensisSystems: System[],
};

const ADD_LICENSE = 'admin/licenseAction/ADD_LICENSE';
const ADD_LICENSE_FAIL = 'admin/licenseAction/ADD_LICENSE_FAIL';
const ADD_LICENSE_SUCCESS = 'admin/licenseAction/ADD_LICENSE_SUCCESS';

const GET_EXTENSIS_ACCOUNT = 'admin/licenseAction/GET_EXTENSIS_ACCOUNT';
const GET_EXTENSIS_ACCOUNT_FAIL =
  'admin/licenseAction/GET_EXTENSIS_ACCOUNT_FAIL';
const GET_EXTENSIS_ACCOUNT_SUCCESS =
  'admin/licenseAction/GET_EXTENSIS_ACCOUNT_SUCCESS';

const GET_EXTENSIS_SYSTEMS = 'admin/licenseAction/GET_EXTENSIS_SYSTEMS';
const GET_EXTENSIS_SYSTEMS_FAIL =
  'admin/licenseAction/GET_EXTENSIS_SYSTEMS_FAIL';
const GET_EXTENSIS_SYSTEMS_SUCCESS =
  'admin/licenseAction/GET_EXTENSIS_SYSTEMS_SUCCESS';

const GET_LICENSING_INFO = 'admin/licenseAction/GET_LICENSING_INFO';
const GET_LICENSING_INFO_FAIL = 'admin/licenseAction/GET_LICENSING_INFO_FAIL';
const GET_LICENSING_INFO_SUCCESS =
  'admin/licenseAction/GET_LICENSING_INFO_SUCCESS';

const SET_EXTENSIS_ACCOUNT = 'admin/licenseAction/SET_EXTENSIS_ACCOUNT';
const SET_EXTENSIS_ACCOUNT_FAIL =
  'admin/licenseAction/SET_EXTENSIS_ACCOUNT_FAIL';
const SET_EXTENSIS_ACCOUNT_SUCCESS =
  'admin/licenseAction/SET_EXTENSIS_ACCOUNT_SUCCESS';

const SET_EXTENSIS_SYSTEM = 'admin/licenseAction/SET_EXTENSIS_SYSTEM';
const SET_EXTENSIS_SYSTEM_FAIL = 'admin/licenseAction/SET_EXTENSIS_SYSTEM_FAIL';
const SET_EXTENSIS_SYSTEM_SUCCESS =
  'admin/licenseAction/SET_EXTENSIS_SYSTEM_SUCCESS';

const SET_IS_PENDING_RESPONSE = 'admin/licenseAction/SET_IS_PENDING_RESPONSE';
const CLEAR_IS_PENDING_RESPONSE =
  'admin/licenseAction/CLEAR_IS_PENDING_RESPONSE';

export {
  ADD_LICENSE,
  ADD_LICENSE_FAIL,
  ADD_LICENSE_SUCCESS,
  CLEAR_IS_PENDING_RESPONSE,
  GET_EXTENSIS_ACCOUNT,
  GET_EXTENSIS_ACCOUNT_FAIL,
  GET_EXTENSIS_ACCOUNT_SUCCESS,
  GET_EXTENSIS_SYSTEMS,
  GET_EXTENSIS_SYSTEMS_FAIL,
  GET_EXTENSIS_SYSTEMS_SUCCESS,
  GET_LICENSING_INFO,
  GET_LICENSING_INFO_FAIL,
  GET_LICENSING_INFO_SUCCESS,
  SET_EXTENSIS_ACCOUNT,
  SET_EXTENSIS_ACCOUNT_FAIL,
  SET_EXTENSIS_ACCOUNT_SUCCESS,
  SET_EXTENSIS_SYSTEM,
  SET_EXTENSIS_SYSTEM_FAIL,
  SET_EXTENSIS_SYSTEM_SUCCESS,
  SET_IS_PENDING_RESPONSE,
};

type AddLicenseAction = {|
  type: 'admin/licenseAction/ADD_LICENSE',
  payload: { session: string },
|};

type AddLicenseFailAction = {|
  type: 'admin/licenseAction/ADD_LICENSE_FAIL',
|};

type AddLicenseSuccessAction = {|
  type: 'admin/licenseAction/ADD_LICENSE_SUCCESS',
|};

type ClearIsPendingResponse = {|
  type: 'admin/licenseAction/CLEAR_IS_PENDING_RESPONSE',
|};

type GetExtensisAccountAction = {|
  type: 'admin/licenseAction/GET_EXTENSIS_ACCOUNT',
  payload: { session: string },
|};

type GetExtensisAccountFailAction = {|
  type: 'admin/licenseAction/GET_EXTENSIS_ACCOUNT_FAIL',
|};

type GetExtensisAccountSuccessAction = {|
  type: 'admin/licenseAction/GET_EXTENSIS_ACCOUNT_SUCCESS',
  payload: {| +account: string |},
|};

type GetExtensisSystemsAction = {|
  type: 'admin/licenseAction/GET_EXTENSIS_SYSTEMS',
  payload: { session: string },
|};

type GetExtensisSystemsFailAction = {|
  type: 'admin/licenseAction/GET_EXTENSIS_SYSTEMS_FAIL',
|};

type GetExtensisSystemsSuccessAction = {|
  type: 'admin/licenseAction/GET_EXTENSIS_SYSTEMS_SUCCESS',
  payload: System[],
|};

type GetLicensingInfoAction = {|
  type: 'admin/licenseAction/GET_LICENSING_INFO',
  payload: { session: string },
|};

type GetLicensingInfoFailAction = {|
  type: 'admin/licenseAction/GET_LICENSING_INFO_FAIL',
|};

type GetLicensingInfoSuccessAction = {|
  type: 'admin/licenseAction/GET_LICENSING_INFO_SUCCESS',
  payload: {| +maintenanceEndDate: string |},
|};

type SetExtensisAccountAction = {|
  type: 'admin/licenseAction/SET_EXTENSIS_ACCOUNT',
  payload: { session: string },
|};

type SetExtensisAccountFailAction = {|
  type: 'admin/licenseAction/SET_EXTENSIS_ACCOUNT_FAIL',
|};

type SetExtensisAccountSuccessAction = {|
  type: 'admin/licenseAction/SET_EXTENSIS_ACCOUNT_SUCCESS',
|};

type SetExtensisSystemAction = {|
  type: 'admin/licenseAction/SET_EXTENSIS_SYSTEM',
  payload: { session: string },
|};

type SetExtensisSystemFailAction = {|
  type: 'admin/licenseAction/SET_EXTENSIS_SYSTEM_FAIL',
|};

type SetExtensisSystemSuccessAction = {|
  type: 'admin/licenseAction/SET_EXTENSIS_SYSTEM_SUCCESS',
|};

type SetIsPendingResponse = {|
  type: 'admin/licenseAction/SET_IS_PENDING_RESPONSE',
|};

export type Action =
  | AddLicenseAction
  | AddLicenseFailAction
  | AddLicenseSuccessAction
  | ClearIsPendingResponse
  | GetExtensisAccountAction
  | GetExtensisAccountFailAction
  | GetExtensisAccountSuccessAction
  | GetExtensisSystemsAction
  | GetExtensisSystemsFailAction
  | GetExtensisSystemsSuccessAction
  | GetLicensingInfoAction
  | GetLicensingInfoFailAction
  | GetLicensingInfoSuccessAction
  | SetExtensisAccountAction
  | SetExtensisAccountFailAction
  | SetExtensisAccountSuccessAction
  | SetExtensisSystemAction
  | SetExtensisSystemFailAction
  | SetExtensisSystemSuccessAction
  | SetIsPendingResponse;



// WEBPACK FOOTER //
// ./src/state/types/licenseTypes.js